/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, Delegate_$type, fromEnum, runOn, markType, INotifyPropertyChanged_$type, PropertyChangedEventArgs } from "igniteui-react-core";
import { List$1 } from "igniteui-react-core";
import { NativeUI } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var IconView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IconView, _super);
    function IconView() {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.g = null;
        _this.b = null;
        _this.f = new List$1(Delegate_$type, 0);
        _this.k = null;
        _this.c = true;
        _this.h = null;
        _this.i = null;
        return _this;
    }
    IconView.prototype.r = function () {
    };
    IconView.prototype.d = function () {
        return true;
    };
    Object.defineProperty(IconView.prototype, "j", {
        get: function () {
            return this.h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IconView.prototype, "w", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IconView.prototype, "e", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    IconView.prototype.p = function (a) {
        var e_1, _a;
        if (a == null) {
            try {
                for (var _b = tslib_1.__values(fromEnum(this.f)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
            this.f.clear();
        }
        this.g = a;
        a.rootWrapper.setStyleProperty("position", "relative");
        this.g.rootWrapper.setStyleProperty("display", "flex");
        this.g.rootWrapper.setStyleProperty("flex-direction", "row");
        this.g.rootWrapper.setStyleProperty("flex-wrap", "no-wrap");
        this.g.rootWrapper.setStyleProperty("align-items", "center");
        this.t();
        var c = this.g.createElementNS("svg", "http://www.w3.org/2000/svg");
        c.setStyleProperty("position", "absolute");
        c.setStyleProperty("top", "0");
        c.setStyleProperty("left", "0");
        c.setStyleProperty("right", "0");
        c.setStyleProperty("bottom", "0");
        c.setAttribute("viewBox", "0 0 24 24");
        this.h = c;
        var d = this.g.createElementNS("path", "http://www.w3.org/2000/svg");
        d.setAttribute("d", "");
        this.h.append(d);
        if (this.k != null) {
            d.setAttribute("d", this.k);
        }
        this.i = d;
        this.g.append(this.h);
        this.a.a6();
    };
    IconView.prototype.u = function (a) {
        if (this.k != a) {
            this.k = a;
            if (this.i != null) {
                this.i.setAttribute("d", this.k);
            }
        }
    };
    IconView.prototype.t = function () {
        this.g.rootWrapper.setStyleProperty("width", "1.5rem");
        this.g.rootWrapper.setStyleProperty("height", "1.5rem");
    };
    IconView.prototype.l = function (a) {
    };
    IconView.prototype.s = function () {
        if (this.d()) {
        }
    };
    IconView.prototype.m = function (a) {
        this.a.a3();
    };
    IconView.prototype.n = function (a) {
        this.a.a4();
    };
    IconView.prototype.o = function () {
        this.c = true;
        this.f.add(this.g.rootWrapper.listen("mouseenter", runOn(this, this.m)));
        this.f.add(this.g.rootWrapper.listen("mouseleave", runOn(this, this.n)));
    };
    IconView.prototype.q = function () {
        var e_2, _a;
        this.c = false;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.f)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
        this.f.clear();
    };
    IconView.prototype.v = function (a) {
        if (a != null) {
            this.g.rootWrapper.setStyleProperty("font", a.fontString);
        }
    };
    IconView.$t = markType(IconView, 'IconView');
    return IconView;
}(Base));
export { IconView };
/**
 * @hidden
 */
var Icon = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Icon, _super);
    function Icon() {
        var _this = _super.call(this) || this;
        _this._view = null;
        _this.bb = Icon.br;
        _this.bf = Icon.bv;
        _this.bc = Icon.bs;
        _this.bd = Icon.bt;
        _this.be = Icon.bu;
        _this.l = Icon.r;
        _this.m = Icon.s;
        _this.bg = Icon.br;
        _this.bl = Icon.bv;
        _this.aa = null;
        _this.bh = Icon.bs;
        _this.bi = Icon.bt;
        _this.bk = Icon.bu;
        _this.n = Icon.r;
        _this.o = Icon.s;
        _this.b = null;
        _this.bj = null;
        _this.z = "ig-icon-" + Icon.x++;
        _this.v = 0;
        _this.d = false;
        _this.y = null;
        _this.f = false;
        _this.e = false;
        _this.propertyChanged = null;
        var a = new IconView();
        a.a = _this;
        _this.view = a;
        _this.view.r();
        return _this;
    }
    Object.defineProperty(Icon.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: true,
        configurable: true
    });
    Icon.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Icon.prototype.a5 = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.a7(a, b, c);
    };
    Icon.prototype.a7 = function (a, b, c) {
        switch (a) {
            case "Fill":
            case "Stroke":
            case "StrokeThickness":
            case "HoverFill":
            case "HoverStroke":
            case "HoverStrokeThickness":
                this.ba();
                break;
            case "ActualFill":
            case "ActualStroke":
            case "ActualHoverFill":
            case "ActualHoverStroke":
            case "ActualStrokeThickness":
            case "ActualHoverStrokeThickness":
            case "SVGPath":
                this.a9();
                break;
        }
    };
    Icon.prototype.ba = function () {
        this.bm = this.bw != null ? this.bw : Icon.br;
        this.bn = this.bx != null ? this.bx : Icon.bs;
        this.bp = this.b0 != null ? this.b0 : Icon.bu;
        this.bo = this.by != null ? this.by : Icon.bt;
        this.q = !isNaN_(this.u) ? this.u : Icon.s;
        this.p = !isNaN_(this.t) ? this.t : Icon.r;
        this.bq = this.b1 != null ? this.b1 : Icon.bv;
    };
    Object.defineProperty(Icon.prototype, "h", {
        get: function () {
            return this.svgPath != null && !this.view.e;
        },
        enumerable: true,
        configurable: true
    });
    Icon.prototype.a9 = function () {
        var a = this.view.j;
        if (this.h) {
            var b = this.view.w;
            if (this.j) {
                b._fill = this.bn;
                b._stroke = this.bo;
                b.ac = this.p;
            }
            else {
                b._fill = this.bm;
                b._stroke = this.bp;
                b.ac = this.q;
            }
        }
        else {
            if (this.svgPath != null) {
                this.view.u(this.svgPath);
            }
            var c = this.view.j;
            if (this.j) {
                if (this.bn != null) {
                    NativeUI.o(c, this.bn);
                }
                if (this.bo != null) {
                    NativeUI.v(c, this.bo);
                }
                if (!isNaN_(this.p)) {
                    NativeUI.y(c, this.p);
                }
            }
            else {
                if (this.bm != null) {
                    NativeUI.o(c, this.bm);
                }
                if (this.bp != null) {
                    NativeUI.v(c, this.bp);
                }
                if (!isNaN_(this.q)) {
                    NativeUI.y(c, this.q);
                }
            }
        }
        if (this.c != null) {
            this.view.v(this.c);
        }
        if (this.bq != null) {
            NativeUI.n(this.view.j, this.bq);
        }
    };
    Object.defineProperty(Icon.prototype, "bm", {
        get: function () {
            return this.bb;
        },
        set: function (a) {
            var b = this.bb;
            this.bb = a;
            if (b != this.bb) {
                this.a5("ActualFill", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "bq", {
        get: function () {
            return this.bf;
        },
        set: function (a) {
            var b = this.bf;
            this.bf = a;
            if (b != this.bf) {
                this.a5("ActualTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "bn", {
        get: function () {
            return this.bc;
        },
        set: function (a) {
            var b = this.bc;
            this.bc = a;
            if (b != this.bc) {
                this.a5("ActualHoverFill", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "bo", {
        get: function () {
            return this.bd;
        },
        set: function (a) {
            var b = this.bd;
            this.bd = a;
            if (b != this.bd) {
                this.a5("ActualHoverStroke", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "bp", {
        get: function () {
            return this.be;
        },
        set: function (a) {
            var b = this.be;
            this.be = a;
            if (b != this.be) {
                this.a5("ActualStroke", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "p", {
        get: function () {
            return this.l;
        },
        set: function (a) {
            var b = this.l;
            this.l = a;
            if (b != this.l) {
                this.a5("ActualHoverStrokeThickness", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "q", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            var b = this.m;
            this.m = a;
            if (b != this.m) {
                this.a5("ActualStrokeThickness", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "bw", {
        get: function () {
            return this.bg;
        },
        set: function (a) {
            var b = this.bg;
            this.bg = a;
            if (b != this.bg) {
                this.a5("Fill", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "b1", {
        get: function () {
            return this.bl;
        },
        set: function (a) {
            var b = this.bl;
            this.bl = a;
            if (b != this.bl) {
                this.a5("TextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "svgPath", {
        get: function () {
            return this.aa;
        },
        set: function (a) {
            var b = this.aa;
            this.aa = a;
            if (b != this.aa) {
                this.a5("SVGPath", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "bx", {
        get: function () {
            return this.bh;
        },
        set: function (a) {
            var b = this.bh;
            this.bh = a;
            if (b != this.bh) {
                this.a5("HoverFill", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "by", {
        get: function () {
            return this.bi;
        },
        set: function (a) {
            var b = this.bi;
            this.bi = a;
            if (b != this.bi) {
                this.a5("HoverStroke", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "b0", {
        get: function () {
            return this.bk;
        },
        set: function (a) {
            var b = this.bk;
            this.bk = a;
            if (b != this.bk) {
                this.a5("Stroke", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "t", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            var b = this.n;
            this.n = a;
            if (b != this.n) {
                this.a5("HoverStrokeThickness", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "u", {
        get: function () {
            return this.o;
        },
        set: function (a) {
            var b = this.o;
            this.o = a;
            if (b != this.o) {
                this.a5("StrokeThickness", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Icon.prototype.a3 = function () {
        this.j = true;
    };
    Icon.prototype.a4 = function () {
        this.j = false;
    };
    Object.defineProperty(Icon.prototype, "c", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            var b = this.b;
            this.b = a;
            if (b != this.b) {
                this.a5("TextStyle", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "bz", {
        get: function () {
            return this.bj;
        },
        set: function (a) {
            var b = this.bj;
            this.bj = a;
            if (b != this.bj) {
                this.a5("HoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "ap", {
        get: function () {
            return this.z;
        },
        set: function (a) {
            var b = this.z;
            this.z = a;
            if (b != this.z) {
                this.a5("Id", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "g", {
        get: function () {
            return this.d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "w", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            var b = this.v;
            this.v = a;
            this.d = true;
            if (b != this.v) {
                this.a5("TabIndex", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "ai", {
        get: function () {
            return this.y;
        },
        set: function (a) {
            var b = this.y;
            this.y = a;
            if (b != this.y) {
                this.a5("AriaLabel", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "j", {
        get: function () {
            return this.f;
        },
        set: function (a) {
            var b = this.f;
            this.f = a;
            if (b != this.f) {
                this.a5("IsHover", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icon.prototype, "disabled", {
        get: function () {
            return this.e;
        },
        set: function (a) {
            var b = this.e;
            this.e = a;
            if (b != this.e) {
                this.a5("IsDisabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Icon.prototype.a6 = function () {
    };
    Icon.prototype.onDetachedFromUI = function () {
        this.view.q();
    };
    Icon.prototype.onAttachedToUI = function () {
        this.view.o();
    };
    Icon.prototype.k = function () {
        return this.view.d();
    };
    Icon.prototype.provideContainer = function (a) {
        this.view.p(a);
    };
    Icon.$t = markType(Icon, 'Icon', Base.$, [INotifyPropertyChanged_$type]);
    Icon.br = null;
    Icon.bv = null;
    Icon.bu = null;
    Icon.bs = null;
    Icon.bt = null;
    Icon.s = 0;
    Icon.r = 0;
    Icon.x = 0;
    return Icon;
}(Base));
export { Icon };
//# sourceMappingURL=IconView_combined.js.map
